import { Reveal } from "@/components/okaia/Reveal";

const STAGES = [
  {
    step: "Étape 1",
    label: "Le point de départ",
    name: "L'œuf",
    img: "/meta-oeuf.jpg",
    alt: "Illustration : un œuf de papillon posé sur une feuille",
    entreprise: "Un projet à lancer ou une difficulté à comprendre.",
    formation: "Une envie d'évolution ou de nouveau métier à préciser.",
  },
  {
    step: "Étape 2",
    label: "Explorer",
    name: "La chenille",
    img: "/meta-chenille.jpg",
    alt: "Illustration : une chenille progressant sur une branche",
    entreprise: "Examiner votre offre, vos clients et les démarches déjà tentées.",
    formation: "Préciser votre objectif, vos acquis et vos contraintes.",
  },
  {
    step: "Étape 3",
    label: "Préparer",
    name: "La chrysalide",
    img: "/meta-chrysalide.jpg",
    alt: "Illustration : une chrysalide suspendue à une branche",
    entreprise: "Choisir une priorité et organiser vos prochaines actions.",
    formation: "Examiner les pistes de formation et les conditions d'accès.",
  },
  {
    step: "Étape 4",
    label: "Passer à l'action",
    name: "Le papillon",
    img: "/meta-papillon.jpg",
    alt: "Illustration : un papillon déployant ses ailes",
    entreprise: "Mettre en œuvre votre plan et observer les premiers retours.",
    formation: "Choisir votre prochaine démarche et engager votre parcours.",
  },
];

export const MetamorphoseFrise = () => (
  <section
    id="metamorphose"
    data-testid="section-metamorphose"
    style={{ scrollMarginTop: "90px" }}
    className="bg-[#0B2215] py-16 md:py-24"
  >
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <Reveal>
        <p className="okaia-overline mb-6 text-[#C8A97E]">La métamorphose OKAÏA</p>
        <h2 className="max-w-3xl font-serif-display text-4xl leading-[1.1] tracking-tight text-[#F9F8F6] md:text-5xl">
          Une transformation qui se construit étape par étape
        </h2>
        <p className="mt-6 max-w-2xl text-base font-light leading-relaxed text-[#A3B1AA] md:text-lg">
          Faire évoluer son entreprise ou préparer un nouveau métier commence par comprendre sa
          situation. La métamorphose du papillon illustre ce chemin&nbsp;: observer, préparer le
          changement, puis passer à l'action.
        </p>
      </Reveal>
      <div className="mt-12 grid gap-px bg-[#C8A97E]/20 sm:grid-cols-2 lg:grid-cols-4">
        {STAGES.map((s, i) => (
          <Reveal key={i} delay={i * 0.08} className="bg-[#0B2215]">
            <div data-testid={`meta-stage-${i + 1}`} className="flex h-full flex-col p-6 md:p-7">
              <img src={s.img} alt={s.alt} className="aspect-[4/3] w-full border border-[#C8A97E]/20 object-cover" loading="lazy" />
              <p className="okaia-overline mt-5 text-[#C8A97E]">
                {s.step} — {s.label}
              </p>
              <h3 className="mt-2 font-serif-display text-xl italic tracking-tight text-[#F9F8F6]">
                {s.name}
                {i < 3 && <span aria-hidden="true" className="ml-2 text-[#C8A97E]">→</span>}
              </h3>
              <div className="mt-4 space-y-3 text-sm font-light leading-relaxed">
                <p className="text-[#F9F8F6]/90">
                  <span className="font-medium text-[#C8A97E]">Entreprise</span> — {s.entreprise}
                </p>
                <p className="text-[#F9F8F6]/90">
                  <span className="font-medium text-[#C8A97E]">Formation</span> — {s.formation}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.15}>
        <p data-testid="metamorphose-note" className="mt-8 max-w-2xl border-l border-[#C8A97E]/60 pl-5 text-sm font-light italic leading-relaxed text-[#A3B1AA]">
          Cette illustration représente une démarche progressive&nbsp;: le diagnostic ou
          l'orientation vous aide à préparer la suite.
        </p>
      </Reveal>
    </div>
  </section>
);
